// language=GraphQL
export const ALL_EMPLOYEES_BLOCKS_QUERY = `query Query($withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {
  employeesBlocks: cmsEmployeesBlocks {
    id
    employees @include(if: $withEmployees) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withEmployeesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
  }
}`

// language=GraphQL
export const SINGLE_EMPLOYEES_BLOCK_QUERY = `query Query($id: ID!, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {
  employeesBlock: cmsEmployeesBlock(id: $id) {
    id
    employees @include(if: $withEmployees) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withEmployeesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
  }
}`

// language=GraphQL
export const CREATE_EMPLOYEES_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsEmployeesBlockInput, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {
    employeesBlock: createCmsEmployeesBlock(input: $input) {
      id
      employees @include(if: $withEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
    }
  }`

// language=GraphQL
export const UPDATE_EMPLOYEES_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsEmployeesBlockInput, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {
    employeesBlock: updateCmsEmployeesBlock(input: $input) {
      id
      employees @include(if: $withEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
    }
  }`

// language=GraphQL
export const DELETE_EMPLOYEES_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsEmployeesBlockInput) {
    deleteCmsEmployeesBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_EMPLOYEES_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsEmployeesBlockInput) {
    forceDeleteCmsEmployeesBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = `
  mutation Mutation($input: addCmsEmployeesBlockEmployeesInput) {
    addCmsEmployeesBlockEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const REMOVE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = `
  mutation Mutation($input: removeCmsEmployeesBlockEmployeesInput) {
    removeCmsEmployeesBlockEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const CREATE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = `
  mutation Mutation($input: createCmsEmployeesBlockEmployeesInput) {
    createCmsEmployeesBlockEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const DELETE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = `
  mutation Mutation($input: deleteCmsEmployeesBlockEmployeesInput) {
    deleteCmsEmployeesBlockEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const UPDATE_EMPLOYEES_BLOCK_EMPLOYEES_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsEmployeesBlockEmployeesOrderInput) {
    updateCmsEmployeesBlockEmployeesOrder(input: $input) {
      id
      employeeIds
    }
  }`
